export default "__VITE_ASSET__CfNCN$BR__"